import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../constants/appconstants';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private headers = new HttpHeaders().set('Content-Type', 'application/json');
  constructor(public http: HttpClient) { }

  public value: BehaviorSubject<any> = new BehaviorSubject(false);


  public profileImageUrl: BehaviorSubject<any> = new BehaviorSubject('');
  getProfileObs(): Observable<any> {
    return this.profileImageUrl.asObservable();
  }

  setProfileObs(profileUrl: any) {
    this.profileImageUrl.next(profileUrl);
  }

 
  addHostToUrl(url: string): string {
    return `${environment.baseUrl}${url}`;
  }

  //add header - "Client_Code"
  doPostWithEmailHead(url: string, data: any, cleintCode: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, JSON.stringify(data), { headers: { 'Content-Type': 'application/json', 'Client_Code': cleintCode }, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPostWithParamsAndResponseForWebPush(url: string, data: any, successCallBack: any, errorCallBack: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
      .append(AppConstants.AUTH_TOKEN_STRING, 'key=' + AppConstants.FIREBASE_SERVER_KEY);
    this.http.post(url, JSON.stringify(data), { headers: headers, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  //used for get-login-otp - removed JSON.stringify(data)
  doPostWithEmailHead2(url: string, data: any, cleintCode: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, data, { headers: { 'Content-Type': 'application/json', 'Client_Code': cleintCode }, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPutWithEmailPwdHead(url: any, data: any, cleintCode: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.put(url, JSON.stringify(data), { headers: { 'Content-Type': 'application/json', 'Client_Code': cleintCode }, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doGetWithEmailHead(url: string, cleintCode: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.get(url, { headers: { 'Content-Type': 'application/json', 'Client_Code': cleintCode }, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doGetRequest(url: string): Observable<any> {
    url = this.addHostToUrl(url);
    return this.http.get<any>(url);
  }

  doPostRequest(url: string, data: any): Observable<any> {
    url = this.addHostToUrl(url);
    return this.http.post<any>(url, data);
  }

  doPutRequest(url: string, data: any): Observable<any> {
    url = this.addHostToUrl(url);
    return this.http.put<any>(url, data);
  }

  doDeleteRequest(url: string): Observable<{}> {
    url = this.addHostToUrl(url);
    return this.http.delete(url);
  }

  doGetRequestWithResponse(url: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.get(url, { headers: this.headers, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPostRequestWithResponse(url: string, data: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, JSON.stringify(data), { headers: this.headers, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPutRequestWithResponse(url: string, data: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.put(url, JSON.stringify(data), { headers: this.headers, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doDeleteRequestWithResponse(url: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.delete(url, { headers: this.headers, observe: 'response' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPostFile(url: string, data: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, data).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doGetWithPdf(url, successCallBack, errorCallBack) {
    url = this.addHostToUrl(url);
    this.http.get(url, { headers: { 'Content-Type': 'application/pdf', 'Accept': 'application/pdf' }, responseType: 'blob' as 'json' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doGetWithBase64(url, successCallBack, errorCallBack) {
    url = this.addHostToUrl(url);
    this.http.get(url, { headers: this.headers, observe: 'response', responseType: 'text' }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

  doPostForJobs(url: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, { headers: this.headers, observe: 'response'  }).subscribe(response => {
      successCallBack(response);
    }, error => {
      errorCallBack(error);
    });
  }

}
